import { ENV_VARS } from '@/helpers/constants'
import { useAuthStore } from '@/stores/auth'
import { useCallStore } from '@/stores/call'
import { useCapabilitiesStore } from '@/stores/capabilities'
import { useChatStore } from '@/stores/chat'
import { useConversationsStore } from '@/stores/conversations'
import { useDevicesStore } from '@/stores/devices'
import { FEATURES, isFeatureEnabled, useFeaturesStore } from '@/stores/features'
import { useMainStore } from '@/stores/main'
import { useResourcesStore } from '@/stores/resources'
import { useRoomStore } from '@/stores/room'
import { useRoomSessionStore } from '@/stores/roomSession'
import { useUiStore } from '@/stores/ui'
import { useUserStore } from '@/stores/user'
import { useUserSettingsStore } from '@/stores/userSettings'

// expose the stores to be used from the console for debugging purposes
if (
  ENV_VARS.IS_DEVELOPMENT ||
  ENV_VARS.IS_TESTING ||
  isFeatureEnabled(FEATURES.WINDOW_EXPOSE_STORES)
) {
  window.__authStore = useAuthStore
  window.__callStore = useCallStore
  window.__capabilitiesStore = useCapabilitiesStore
  window.__chatStore = useChatStore
  window.__conversationsStore = useConversationsStore
  window.__devicesStore = useDevicesStore
  window.__featuresStore = useFeaturesStore
  window.__mainStore = useMainStore
  window.__resourcesStore = useResourcesStore
  window.__roomSessionStore = useRoomSessionStore
  window.__roomStore = useRoomStore
  window.__uiStore = useUiStore
  window.__userSettingsStore = useUserSettingsStore
  window.__userStore = useUserStore
}
